import React from "react";

export default function Footer(){
    return(
        <div className="footer">
        <a
        href="https://github.com/TalitAlves/new-react-weather-app.git"
        target="blank" >
        Open-sorce code 
      </a>
       <span> by Talita Alves </span>
      
      </div>
    
       );
}